import TodaysReportContainer from "./TodaysReportContainer";

export default TodaysReportContainer;
